<div class="appContentsContainer">
  <form
    [formGroup]="downloadHistoricoPlaca"
    (ngSubmit)="onSubmit()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        <div class="pageTitle">Exportar datos histórico placa</div>
      </div>
    </div>
    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="bastidor">Bastidor </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="bastidor"
              type="text"
              formControlName="bastidor"
              minlength="8"
              maxlength="17"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="fechaInicio">Fecha Inicio</label>
            </div>
          </div>
          <div class="inputContainer">
            <input id="fechaInicio" type="date" formControlName="fechaInicio" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="fechaFin">Fecha Final </label>
            </div>
          </div>
          <div class="inputContainer">
            <input id="fechaFin" type="date" formControlName="fechaFin" />
          </div>
        </div>
      </div>
      <div class="formGroupButtons detalleFormGroupButtonsFooter">
        <div class="formButton">
          <button
            type="button"
            class="submitButton"
            *ngIf="!downloadHistoricoPlaca.pristine"
            [swal]="confirmSwal"
          >
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
          <button
            type="button"
            class="submitButton"
            *ngIf="downloadHistoricoPlaca.pristine"
            (click)="goPredefinedMailBox()"
          >
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
        </div>

        <div class="formButton middleButtonAceptarContainer">
          <div class="middleButtonAceptar formButton">
            <button type="submit" class="submitButton">Exportar</button>
          </div>
        </div>
      </div>
      <swal
        #confirmSwal
        title="Tienes cambios sin guardar"
        text="¿Quieres volver sin guardar?"
        icon="warning"
        [showCancelButton]="true"
        [focusCancel]="true"
        [swalOptions]="{
          allowEscapeKey: false,
          allowOutsideClick: false
        }"
        (confirm)="goPredefinedMailBox()"
      >
      </swal>
    </div>
  </form>
</div>
